export const MyPlacesIcon = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.8"
        d="M5 5.77671V11.6774L10.6683 11.5521V5.4L5 5.77671ZM5 14.2308L18.5743 14.0418V28.8788L5 28.0822V14.2308ZM21.5065 4.77808V11.1336H28V4.5L21.5065 4.77808ZM21.5065 13.9377V29.15L28 29.5V13.9377H21.5065Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CommercialsIcon = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8132 18.1048V28.4754H7.11766V16.5707H25.6497V28.4754H24.7906V18.1048V17.4298H24.1156H17.4882H16.8132V18.1048ZM7.97676 22.523V23.198H8.65177H15.2791H15.9541V22.523V18.1048V17.4298H15.2791H8.65177H7.97676V18.1048V22.523ZM30.013 13.0116H2.75438C2.99489 10.4311 3.6421 7.90436 4.67252 5.52511H28.0949C29.1253 7.90433 29.7726 10.4311 30.013 13.0116Z"
        stroke="currentColor"
        stroke-opacity="0.8"
        stroke-width="1.35002"
      />
    </svg>
  );
};

export const ProfileIcon = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.9796 20.4614C10.8228 20.4614 6.41895 21.2411 6.41895 24.3636C6.41895 27.4862 10.7948 28.2938 15.9796 28.2938C21.1364 28.2938 25.5389 27.5129 25.5389 24.3916C25.5389 21.2703 21.1643 20.4614 15.9796 20.4614Z"
          stroke={"currentColor"}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.9799 16.0077C19.364 16.0077 22.1068 13.2636 22.1068 9.87943C22.1068 6.4953 19.364 3.75244 15.9799 3.75244C12.5957 3.75244 9.8516 6.4953 9.8516 9.87943C9.84017 13.2521 12.5652 15.9962 15.9367 16.0077H15.9799Z"
          stroke={"currentColor"}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export const FAQIcon = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          d="M20 15.18L17.41 12.59L16 14L20 18L26 12L24.59 10.59L20 15.18ZM8 18H10V20H8V18ZM12 9H7V11H11V13H8V16H10V15H12C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14V10C13 9.73478 12.8946 9.48043 12.7071 9.29289C12.5196 9.10536 12.2652 9 12 9Z"
          fill="currentColor"
        />
        <path
          d="M17.736 30L16 29L20 22H26C27.107 22 28 21.107 28 20V8C28 6.893 27.107 6 26 6H6C4.893 6 4 6.893 4 8V20C4 21.107 4.893 22 6 22H15V24H6C4.93913 24 3.92172 23.5786 3.17157 22.8284C2.42143 22.0783 2 21.0609 2 20V8C2 5.79 3.79 4 6 4H26C28.21 4 30 5.79 30 8V20C30 21.0609 29.5786 22.0783 28.8284 22.8284C28.0783 23.5786 27.0609 24 26 24H21.165L17.736 30Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const CheckIcon = ({ size, checked }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill={checked ? "currentColor" : "none"}
      stroke={checked ? "currentColor" : "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.1965 24.651V36.9766C41.1965 38.0663 40.7636 39.1113 39.9931 39.8818C39.2226 40.6523 38.1776 41.0852 37.0879 41.0852H12.4367C11.347 41.0852 10.302 40.6523 9.53149 39.8818C8.76099 39.1113 8.32813 38.0663 8.32812 36.9766V12.3253C8.32812 11.2357 8.76099 10.1907 9.53149 9.42016C10.302 8.64966 11.347 8.2168 12.4367 8.2168H30.9251"
        stroke="currentColor"
        stroke-width="4.10854"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M18.5996 22.5966L24.7624 28.7594L41.1966 12.3252"
        stroke={checked ? "#eeee" : "currentColor"}
        stroke-width="4.10854"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SpecialEventIcon = ({ size, checked }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.409 24.6278V36.8178C40.409 37.8955 39.9809 38.929 39.2188 39.691C38.4568 40.453 37.4233 40.8811 36.3456 40.8811H11.9657C10.888 40.8811 9.85449 40.453 9.09246 39.691C8.33044 38.929 7.90234 37.8955 7.90234 36.8178V12.4378C7.90234 11.3602 8.33044 10.3267 9.09246 9.56463C9.85449 8.80261 10.888 8.37451 11.9657 8.37451H30.2506"
        stroke="url(#paint2_linear_1604_5411)"
        fill={checked ? "url(#paint2_linear_1604_5411)" : "none"}
        stroke-width="4.02167"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.7705 21.4651C19.6857 22.3697 19.6262 23.9706 20.1603 24.6521C20.1603 24.6521 19.9089 22.8934 22.1629 20.687C23.0705 19.7987 23.2803 18.5906 22.9634 17.6845C22.7834 17.1712 22.4546 16.7472 22.1689 16.4511C22.0023 16.277 22.1302 15.9899 22.3727 16.0003C23.8397 16.0657 26.2173 16.4734 27.2275 19.0087C27.6709 20.1216 27.7037 21.2717 27.4924 22.4411C27.3585 23.188 26.8824 24.8485 27.9685 25.0523C28.7437 25.1981 29.1186 24.5821 29.2867 24.1388C29.3566 23.9543 29.5992 23.9081 29.7301 24.0554C31.0394 25.5448 31.151 27.2989 30.8802 28.8091C30.3565 31.7282 27.4001 33.8529 24.4631 33.8529C20.7941 33.8529 17.8735 31.7535 17.1162 27.9536C16.8112 26.4196 16.9659 23.3844 19.3316 21.2419C19.5071 21.0812 19.7943 21.2241 19.7705 21.4651Z"
        fill="url(#paint0_radial_1604_5411)"
      />
      <path
        d="M25.5809 26.9239C24.2285 25.1831 24.8341 23.1968 25.1658 22.4053C25.2105 22.3011 25.0914 22.2029 24.9977 22.2669C24.416 22.6627 23.2242 23.5941 22.6692 24.9049C21.9179 26.6769 21.9714 27.5443 22.4163 28.6036C22.6841 29.2419 22.3732 29.3773 22.2169 29.4011C22.0652 29.4249 21.9253 29.3237 21.8137 29.2181C21.4927 28.9099 21.264 28.5183 21.1531 28.0874C21.1293 27.9951 21.0088 27.9698 20.9538 28.0457C20.5372 28.6215 20.3214 29.5454 20.311 30.1986C20.2783 32.2176 21.9462 33.8542 23.9637 33.8542C26.5064 33.8542 28.3587 31.0422 26.8977 28.6914C26.4737 28.007 26.0749 27.5592 25.5809 26.9239Z"
        fill="url(#paint1_radial_1604_5411)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_1604_5411"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(23.7364 33.8991) rotate(-179.751) scale(10.5023 17.2322)"
        >
          <stop offset="0.314" stop-color="#FF9800" />
          <stop offset="0.662" stop-color="#FF6D00" />
          <stop offset="0.972" stop-color="#F44336" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_1604_5411"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(24.1035 23.448) rotate(90.5787) scale(10.9886 8.26978)"
        >
          <stop offset="0.214" stop-color="#FFF176" />
          <stop offset="0.328" stop-color="#FFF27D" />
          <stop offset="0.487" stop-color="#FFF48F" />
          <stop offset="0.672" stop-color="#FFF7AD" />
          <stop offset="0.793" stop-color="#FFF9C4" />
          <stop offset="0.822" stop-color="#FFF8BD" stop-opacity="0.804" />
          <stop offset="0.863" stop-color="#FFF6AB" stop-opacity="0.529" />
          <stop offset="0.91" stop-color="#FFF38D" stop-opacity="0.209" />
          <stop offset="0.941" stop-color="#FFF176" stop-opacity="0" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_1604_5411"
          x1="24.1556"
          y1="8.37451"
          x2="24.1556"
          y2="40.8811"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5E2590" />
          <stop offset="1" stop-color="#A31E48" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const UncheckedBox = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.3828 6.07715V27.3471C30.3828 28.153 30.0627 28.9259 29.4928 29.4957C28.923 30.0656 28.1501 30.3857 27.3442 30.3857H9.11279C8.30691 30.3857 7.53404 30.0656 6.9642 29.4957C6.39435 28.9259 6.07422 28.153 6.07422 27.3471V9.11572C6.07422 8.30984 6.39435 7.53697 6.9642 6.96713C7.53404 6.39728 8.30691 6.07715 9.11279 6.07715H29.4928"
        stroke="currentColor"
        stroke-width="3.03857"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SpecialEventAddIcon = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_di_1033_6196)">
        <circle
          cx="17.875"
          cy="13.875"
          r="13.875"
          fill="url(#paint0_linear_1033_6196)"
        />
      </g>
      <g clip-path="url(#clip0_1033_6196)">
        <path
          d="M14.2882 11.0374C14.2092 11.8795 14.1538 13.3699 14.651 14.0043C14.651 14.0043 14.417 12.3671 16.5154 10.313C17.3603 9.4861 17.5556 8.36141 17.2606 7.51789C17.093 7.04003 16.7869 6.64528 16.5209 6.36965C16.3658 6.20759 16.4849 5.94027 16.7107 5.94996C18.0764 6.01091 20.2898 6.39042 21.2302 8.75062C21.643 9.78667 21.6735 10.8573 21.4768 11.946C21.3521 12.6413 20.9089 14.1871 21.92 14.3769C22.6416 14.5126 22.9907 13.9392 23.1472 13.5264C23.2123 13.3547 23.4381 13.3117 23.56 13.4488C24.7788 14.8353 24.8827 16.4683 24.6306 17.8742C24.1431 20.5918 21.3909 22.5697 18.6567 22.5697C15.2411 22.5697 12.5222 20.6153 11.8171 17.0778C11.5332 15.6498 11.6773 12.8242 13.8795 10.8296C14.043 10.68 14.3103 10.813 14.2882 11.0374Z"
          fill="url(#paint1_radial_1033_6196)"
        />
        <path
          d="M19.6994 16.1194C18.4404 14.4989 19.0041 12.6498 19.313 11.9129C19.3545 11.8159 19.2437 11.7245 19.1564 11.7841C18.6149 12.1525 17.5054 13.0196 16.9888 14.2398C16.2893 15.8895 16.3392 16.697 16.7533 17.6832C17.0026 18.2774 16.7131 18.4034 16.5677 18.4256C16.4264 18.4477 16.2962 18.3536 16.1924 18.2552C15.8935 17.9683 15.6805 17.6038 15.5774 17.2025C15.5552 17.1167 15.443 17.0931 15.3918 17.1638C15.0039 17.6998 14.8031 18.5599 14.7934 19.168C14.7629 21.0476 16.3156 22.5712 18.1938 22.5712C20.5609 22.5712 22.2854 19.9533 20.9252 17.7649C20.5305 17.1278 20.1593 16.7108 19.6994 16.1194Z"
          fill="url(#paint2_radial_1033_6196)"
        />
      </g>
      <defs>
        <filter
          id="filter0_di_1033_6196"
          x="0"
          y="0"
          width="35.75"
          height="35.75"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1033_6196"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1033_6196"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.8825 0 0 0 0 0.216667 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_1033_6196"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1033_6196"
          x1="17.875"
          y1="0"
          x2="17.875"
          y2="27.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5E2590" />
          <stop offset="1" stop-color="#E311B6" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_1033_6196"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.9802 22.6127) rotate(-179.751) scale(9.77704 16.0422)"
        >
          <stop offset="0.314" stop-color="#FF9800" />
          <stop offset="0.662" stop-color="#FF6D00" />
          <stop offset="0.972" stop-color="#F44336" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_1033_6196"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.324 12.8836) rotate(90.5787) scale(10.2298 7.69868)"
        >
          <stop offset="0.214" stop-color="#FFF176" />
          <stop offset="0.328" stop-color="#FFF27D" />
          <stop offset="0.487" stop-color="#FFF48F" />
          <stop offset="0.672" stop-color="#FFF7AD" />
          <stop offset="0.793" stop-color="#FFF9C4" />
          <stop offset="0.822" stop-color="#FFF8BD" stop-opacity="0.804" />
          <stop offset="0.863" stop-color="#FFF6AB" stop-opacity="0.529" />
          <stop offset="0.91" stop-color="#FFF38D" stop-opacity="0.209" />
          <stop offset="0.941" stop-color="#FFF176" stop-opacity="0" />
        </radialGradient>
        <clipPath id="clip0_1033_6196">
          <rect
            width="17.7292"
            height="17.7292"
            fill="white"
            transform="translate(9.39648 5.396)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DiscountIcon = ({ color, size }) => {
  return (
    <svg
      width={size?.width ?? "20"}
      height={size?.height ?? "39"}
      viewBox="0 0 20 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1035_6165)">
        <path
          d="M7.03314 1.43555H13.1634V7.50126L11.6308 18.1162H8.5657L7.03314 7.50126V1.43555ZM13.1634 22.6655C13.1726 23.0694 13.1002 23.4711 12.9504 23.8469C12.8006 24.2227 12.5764 24.5651 12.291 24.854C12.0057 25.1429 11.6648 25.3725 11.2885 25.5293C10.9122 25.686 10.5081 25.7668 10.0998 25.767C9.69153 25.7671 9.28734 25.6864 8.91097 25.5299C8.5346 25.3733 8.19365 25.1438 7.90812 24.8551C7.62259 24.5663 7.39825 24.224 7.24825 23.8483C7.09826 23.4725 7.02565 23.0709 7.03467 22.667C7.05238 21.8746 7.38291 21.1205 7.9555 20.5662C8.52808 20.0119 9.29723 19.7014 10.0983 19.7012C10.8993 19.701 11.6686 20.0111 12.2415 20.5652C12.8144 21.1192 13.1453 21.8731 13.1634 22.6655Z"
          fill={color}
        />
        <path
          d="M7.03314 1.1749H6.77249V1.43555V7.50126V7.51998L6.77517 7.5385L8.30773 18.1535L8.33998 18.3769H8.5657H11.6308H11.8565L11.8888 18.1535L13.4214 7.5385L13.424 7.51998V7.50126V1.43555V1.1749H13.1634H7.03314ZM13.1925 23.9434C13.3553 23.535 13.434 23.0986 13.424 22.6596C13.4043 21.7982 13.0446 20.9792 12.4227 20.3778C11.8009 19.7765 10.9665 19.4404 10.0982 19.4406C9.22991 19.4408 8.39567 19.7773 7.7742 20.379C7.15265 20.9807 6.79334 21.7998 6.77409 22.6612C6.76428 23.1002 6.84321 23.5367 7.00618 23.9449C7.16915 24.3532 7.41283 24.7249 7.72277 25.0383C8.03272 25.3518 8.40267 25.6007 8.81084 25.7705C9.21901 25.9403 9.65726 26.0277 10.0999 26.0276C10.5425 26.0275 10.9807 25.9399 11.3888 25.7699C11.7969 25.5998 12.1667 25.3508 12.4765 25.0372C12.7863 24.7236 13.0298 24.3517 13.1925 23.9434Z"
          stroke="white"
          stroke-width="0.521302"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1035_6165"
          x="0.445355"
          y="0.914062"
          width="19.3066"
          height="37.508"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.06649" />
          <feGaussianBlur stdDeviation="3.03324" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1035_6165"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1035_6165"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const DiscountIcon2 = ({ color }) => {
  return (
    <svg
      width="13"
      height="35"
      viewBox="0 0 13 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.05469 1.93258H1.83663V3.15063V10.2449V10.3315L1.84887 10.4172L3.62244 22.8322L3.77184 23.878H4.31997C3.93931 24.0857 3.58561 24.3462 3.27026 24.6547C2.38009 25.5256 1.86623 26.7104 1.8387 27.9555C1.82467 28.5901 1.93756 29.2211 2.17074 29.8114C2.40393 30.4018 2.75271 30.9396 3.1966 31.3933C3.6405 31.847 4.17057 32.2075 4.75569 32.4535L5.22782 31.3307L4.75569 32.4535C5.34081 32.6995 5.96919 32.8262 6.60393 32.826C7.23867 32.8259 7.86698 32.6989 8.45198 32.4526C9.03698 32.2063 9.56687 31.8455 10.0105 31.3916C10.4542 30.9377 10.8027 30.3997 11.0356 29.8092C11.2685 29.2187 11.3811 28.5877 11.3667 27.9531C11.3386 26.7081 10.8241 25.5235 9.93351 24.653C9.61859 24.3452 9.26548 24.0853 8.8855 23.878H9.43182L9.58122 22.8322L11.3548 10.4172L11.367 10.3315V10.2449V3.15063V1.93258H10.149H3.05469Z"
        fill={color}
        stroke="white"
        stroke-width="2.43612"
      />
    </svg>
  );
};

export const DiscountIcon3 = ({ size, color }) => {
  return (
    <svg
      width={size?.width ?? "20"}
      height={size?.height ?? "45"}
      viewBox="0 0 20 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1035_6165)">
        <path
          d="M7.03314 1.43555H13.1634V7.50126L11.6308 18.1162H8.5657L7.03314 7.50126V1.43555ZM13.1634 22.6655C13.1726 23.0694 13.1002 23.4711 12.9504 23.8469C12.8006 24.2227 12.5764 24.5651 12.291 24.854C12.0057 25.1429 11.6648 25.3725 11.2885 25.5293C10.9122 25.686 10.5081 25.7668 10.0998 25.767C9.69153 25.7671 9.28734 25.6864 8.91097 25.5299C8.5346 25.3733 8.19365 25.1438 7.90812 24.8551C7.62259 24.5663 7.39825 24.224 7.24825 23.8483C7.09826 23.4725 7.02565 23.0709 7.03467 22.667C7.05238 21.8746 7.38291 21.1205 7.9555 20.5662C8.52808 20.0119 9.29723 19.7014 10.0983 19.7012C10.8993 19.701 11.6686 20.0111 12.2415 20.5652C12.8144 21.1192 13.1453 21.8731 13.1634 22.6655Z"
          fill={color}
        />
        <path
          d="M7.03314 1.1749H6.77249V1.43555V7.50126V7.51998L6.77517 7.5385L8.30773 18.1535L8.33998 18.3769H8.5657H11.6308H11.8565L11.8888 18.1535L13.4214 7.5385L13.424 7.51998V7.50126V1.43555V1.1749H13.1634H7.03314ZM13.1925 23.9434C13.3553 23.535 13.434 23.0986 13.424 22.6596C13.4043 21.7982 13.0446 20.9792 12.4227 20.3778C11.8009 19.7765 10.9665 19.4404 10.0982 19.4406C9.22991 19.4408 8.39567 19.7773 7.7742 20.379C7.15265 20.9807 6.79334 21.7998 6.77409 22.6612C6.76428 23.1002 6.84321 23.5367 7.00618 23.9449C7.16915 24.3532 7.41283 24.7249 7.72277 25.0383C8.03272 25.3518 8.40267 25.6007 8.81084 25.7705C9.21901 25.9403 9.65726 26.0277 10.0999 26.0276C10.5425 26.0275 10.9807 25.9399 11.3888 25.7699C11.7969 25.5998 12.1667 25.3508 12.4765 25.0372C12.7863 24.7236 13.0298 24.3517 13.1925 23.9434Z"
          stroke="white"
          stroke-width="0.521302"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1035_6165"
          x="0.445355"
          y="0.914062"
          width="19.3066"
          height="37.508"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.06649" />
          <feGaussianBlur stdDeviation="3.03324" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1035_6165"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1035_6165"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const DiscountLargeIcon = () => {
  return (
    <svg
      width="17"
      height="33"
      viewBox="0 0 17 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1701_6370)">
        <path
          d="M5.92517 0.125H11.4514V5.59307L10.0699 15.1622H7.30673L5.92517 5.59307V0.125ZM11.4514 19.2632C11.4597 19.6273 11.3945 19.9894 11.2594 20.3282C11.1244 20.667 10.9223 20.9756 10.665 21.2361C10.4078 21.4965 10.1005 21.7035 9.76129 21.8448C9.42208 21.9861 9.05775 22.059 8.68969 22.0591C8.32163 22.0592 7.95726 21.9865 7.61798 21.8454C7.2787 21.7042 6.97133 21.4974 6.71394 21.2371C6.45654 20.9767 6.2543 20.6682 6.11909 20.3295C5.98388 19.9907 5.91842 19.6287 5.92655 19.2646C5.94252 18.5503 6.24048 17.8705 6.75665 17.3708C7.27282 16.8711 7.96618 16.5912 8.68831 16.591C9.41043 16.5908 10.1039 16.8704 10.6204 17.3698C11.1368 17.8693 11.4351 18.5489 11.4514 19.2632Z"
          fill="#FE3030"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1701_6370"
          x="0.456402"
          y="0.125"
          width="16.4645"
          height="32.8711"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5.46877" />
          <feGaussianBlur stdDeviation="2.73438" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1701_6370"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1701_6370"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const RatingsIcon = ({ size, color }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.92369 2.27781C8.59426 0.291918 11.403 0.291917 12.0736 2.27781L12.8352 4.53315C13.1358 5.4233 13.9706 6.02257 14.9101 6.02257H17.1899C19.3318 6.02257 20.2002 8.78029 18.4447 10.0076L16.7472 11.1943C15.9499 11.7517 15.6159 12.7682 15.9271 13.6899L16.6094 15.7105C17.2858 17.7135 15.0123 19.4174 13.2796 18.2061L11.2535 16.7896C10.4999 16.2627 9.49742 16.2627 8.7438 16.7896L6.71772 18.2061C4.98505 19.4174 2.71155 17.7135 3.3879 15.7105L4.07019 13.6899C4.38142 12.7682 4.04736 11.7517 3.25008 11.1943L1.55257 10.0076C-0.202891 8.78029 0.665502 6.02257 2.80743 6.02257H5.08716C6.0267 6.02257 6.86155 5.4233 7.16213 4.53315L7.92369 2.27781Z"
        fill={color}
      />
    </svg>
  );
};

export const ProfileIcon2 = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="16.0503"
        cy="13.4644"
        r="4.45949"
        stroke="currentColor"
        stroke-width="1.88289"
      />
      <path
        d="M24.9698 26.8433C24.9698 21.9175 20.9766 17.9243 16.0508 17.9243C11.125 17.9243 7.13184 21.9175 7.13184 26.8433"
        stroke="#21005D"
        stroke-width="1.88289"
      />
      <circle
        cx="16.0504"
        cy="15.694"
        r="14.1217"
        stroke="currentColor"
        stroke-width="1.88289"
      />
    </svg>
  );
};

export const LockIcon = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_526_6242)">
        <path
          d="M21.9684 9.93094V8.2924C21.9684 6.15618 21.1198 4.10746 19.6093 2.59693C18.0987 1.0864 16.05 0.237793 13.9138 0.237793C11.7776 0.237793 9.72887 1.0864 8.21834 2.59693C6.70781 4.10746 5.8592 6.15618 5.8592 8.2924V9.93094C4.83438 10.3782 3.9621 11.1144 3.34904 12.0495C2.73598 12.9847 2.4087 14.0782 2.40723 15.1963V22.1003C2.40905 23.6256 3.01579 25.0879 4.09434 26.1665C5.1729 27.245 6.63521 27.8518 8.16052 27.8536H19.6671C21.1924 27.8518 22.6547 27.245 23.7333 26.1665C24.8118 25.0879 25.4186 23.6256 25.4204 22.1003V15.1963C25.4189 14.0782 25.0916 12.9847 24.4786 12.0495C23.8655 11.1144 22.9932 10.3782 21.9684 9.93094ZM8.16052 8.2924C8.16052 6.76653 8.76666 5.30316 9.84562 4.22421C10.9246 3.14526 12.3879 2.53911 13.9138 2.53911C15.4397 2.53911 16.903 3.14526 17.982 4.22421C19.0609 5.30316 19.6671 6.76653 19.6671 8.2924V9.44306H8.16052V8.2924ZM23.1191 22.1003C23.1191 23.0158 22.7554 23.8938 22.108 24.5412C21.4606 25.1886 20.5826 25.5523 19.6671 25.5523H8.16052C7.245 25.5523 6.36697 25.1886 5.7196 24.5412C5.07223 23.8938 4.70854 23.0158 4.70854 22.1003V15.1963C4.70854 14.2808 5.07223 13.4028 5.7196 12.7554C6.36697 12.1081 7.245 11.7444 8.16052 11.7444H19.6671C20.5826 11.7444 21.4606 12.1081 22.108 12.7554C22.7554 13.4028 23.1191 14.2808 23.1191 15.1963V22.1003Z"
          fill="currentColor"
        />
        <path
          d="M13.9143 16.3472C13.6092 16.3472 13.3165 16.4684 13.1007 16.6842C12.8849 16.9 12.7637 17.1927 12.7637 17.4978V19.7991C12.7637 20.1043 12.8849 20.397 13.1007 20.6128C13.3165 20.8286 13.6092 20.9498 13.9143 20.9498C14.2195 20.9498 14.5122 20.8286 14.728 20.6128C14.9438 20.397 15.065 20.1043 15.065 19.7991V17.4978C15.065 17.1927 14.9438 16.9 14.728 16.6842C14.5122 16.4684 14.2195 16.3472 13.9143 16.3472Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_526_6242">
          <rect
            width="27.6158"
            height="27.6158"
            fill="white"
            transform="translate(0.105469 0.237793)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LogoutIcon = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.92973 5.23796C2.92973 3.67812 4.19423 2.41362 5.75407 2.41362H24.583C26.1429 2.41362 27.4074 3.67812 27.4074 5.23796V25.3222C27.4074 26.882 26.1429 28.1465 24.583 28.1465H5.75407C4.19423 28.1465 2.92973 26.882 2.92973 25.3222V5.23796Z"
        stroke="currentColor"
        stroke-width="1.88289"
      />
      <path
        d="M18.6011 15.2798H9.74121"
        stroke="currentColor"
        stroke-width="1.88289"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.2279 10.9132L20.5946 15.2798L16.2279 19.6464"
        stroke="currentColor"
        stroke-width="1.88289"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ShakesIcon = ({}) => {
  return (
    <svg
      width="21"
      height="31"
      viewBox="0 0 21 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7151 0.656356C15.525 0.656407 15.3387 0.711293 15.1771 0.814861C15.0155 0.918429 14.8849 1.06658 14.8 1.24272L13.4654 4.00895C12.4561 3.67342 11.3799 3.48192 10.2594 3.48192C4.85267 3.48192 0.371094 7.71658 0.371094 13.0182C0.371121 13.2992 0.478902 13.5687 0.670733 13.7674C0.862564 13.9661 1.12274 14.0778 1.39402 14.0778H2.16922L2.5648 16.9034H9.2365C9.80116 16.9034 10.2594 17.3773 10.2594 17.9629C10.2594 18.5485 9.80116 19.0225 9.2365 19.0225H2.86182L4.05924 27.5516C4.28224 29.1325 5.68646 30.3248 7.32383 30.3248H13.195C14.8324 30.3248 16.2353 29.1325 16.4583 27.5516L17.657 19.0225H14.0102C13.4455 19.0225 12.9872 18.5485 12.9872 17.9629C12.9872 17.3773 13.4455 16.9034 14.0102 16.9034H17.9541L18.3496 14.0778H19.1248C19.3961 14.0778 19.6563 13.9661 19.8481 13.7674C20.04 13.5687 20.1477 13.2992 20.1478 13.0182C20.1478 9.53363 18.2057 6.51937 15.3435 4.85607L16.3477 2.77553H19.4658C19.6014 2.77751 19.7359 2.75157 19.8617 2.69922C19.9875 2.64686 20.102 2.56913 20.1985 2.47054C20.2951 2.37195 20.3717 2.25447 20.424 2.12493C20.4764 1.99539 20.5033 1.85636 20.5033 1.71594C20.5033 1.57552 20.4764 1.4365 20.424 1.30696C20.3717 1.17742 20.2951 1.05994 20.1985 0.961347C20.102 0.862759 19.9875 0.785026 19.8617 0.732668C19.7359 0.68031 19.6014 0.65437 19.4658 0.656356H15.7151ZM10.2594 5.60109C14.241 5.60109 17.3176 8.41073 17.8768 11.9586H2.64205C3.2013 8.41073 6.27785 5.60109 10.2594 5.60109Z"
        fill="#476C12"
      />
    </svg>
  );
};

export const BreadIcon = () => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.939 0.954102C15.429 0.954102 14.237 1.13455 13.2274 1.52856C13.8897 1.86934 14.5614 2.33849 15.2083 2.98868C15.5532 3.33537 15.5532 3.89682 15.2083 4.24351C15.0364 4.41744 14.8104 4.50382 14.5843 4.50382C14.3583 4.50382 14.1322 4.41744 13.9597 4.2441C12.9013 3.17977 11.7646 2.73369 10.7933 2.57159C9.57068 2.48699 8.32684 2.83604 7.26019 3.58799C6.64739 4.01987 6.1329 4.56002 5.7385 5.16406C7.22663 5.14395 8.97614 5.60068 10.499 7.13061C10.844 7.4773 10.844 8.03874 10.499 8.38543C10.3271 8.55878 10.1011 8.64515 9.87502 8.64515C9.64898 8.64515 9.42293 8.55878 9.25045 8.38543C7.74289 6.8703 6.06285 6.81764 4.96794 7.01288C4.96441 7.02885 4.95911 7.04482 4.95617 7.0608C2.57091 7.85002 1.17932 9.86685 1.2011 12.4043C2.44199 12.4658 4.40459 13.0267 6.43253 15.473C6.74452 15.8493 6.69389 16.409 6.31951 16.7225C6.15468 16.8604 5.95395 16.9278 5.75498 16.9278C5.50186 16.9278 5.25109 16.819 5.07625 16.6083C3.23492 14.388 1.59432 14.1431 0.85673 14.1679C0.396985 15.1263 0.162109 16.3445 0.162109 17.8153C0.162109 19.0086 0.338119 20.3693 1.63317 21.436C2.13118 21.9199 2.72043 22.1459 3.3968 22.1459C5.85388 22.1459 9.45531 19.16 13.9409 14.73C18.141 10.4993 21.3539 7.03772 21.3539 4.20801C21.3539 2.17165 19.1094 0.954102 16.939 0.954102Z"
        fill="#CFA22D"
      />
    </svg>
  );
};

export const PlatterIcon = () => {
  return (
    <svg
      width="26"
      height="21"
      viewBox="0 0 26 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2207 19.1787H3.15305C2.70322 19.1787 2.33912 19.5255 2.33912 19.9528C2.33912 20.3801 2.70322 20.7269 3.15305 20.7269H24.2207C24.6705 20.7269 25.0346 20.3801 25.0346 19.9528C25.0346 19.5255 24.6705 19.1787 24.2207 19.1787ZM11.6374 9.57323C7.10547 10.4149 3.55024 13.9691 3.30281 18.1554C3.32831 18.1518 3.35056 18.1409 3.37715 18.1409H24.0704C23.8159 13.9613 20.2634 10.4139 15.7369 9.57323C15.8253 9.34719 15.8801 9.10619 15.8801 8.85177C15.8801 7.70146 14.8964 6.76583 13.6869 6.76583C12.4774 6.76583 11.4936 7.70146 11.4936 8.85177C11.4936 9.10619 11.549 9.34771 11.6374 9.57323ZM13.6869 8.31403C13.9983 8.31403 14.2523 8.55555 14.2523 8.85177C14.2523 9.1387 14.013 9.3699 13.7146 9.38435C13.7053 9.38435 13.6961 9.38332 13.6869 9.38332C13.6777 9.38332 13.6684 9.38435 13.6592 9.38435C13.3613 9.3699 13.1215 9.1387 13.1215 8.85177C13.1215 8.55555 13.3754 8.31403 13.6869 8.31403ZM10.7025 6.78751C11.1523 6.78751 11.5164 6.44071 11.5164 6.01341C11.5164 5.58611 11.1523 5.23931 10.7025 5.23931H10.0785C9.98569 4.80324 9.81314 4.39555 9.5809 4.02553L10.4502 3.23698C10.7757 2.94179 10.7877 2.45204 10.4773 2.14241C10.1675 1.83225 9.65198 1.82193 9.32641 2.11609L8.48644 2.8778C8.0149 2.54648 7.46903 2.30651 6.87378 2.19195V1.36882C6.87378 0.941522 6.50968 0.594727 6.05985 0.594727C5.61002 0.594727 5.24592 0.941522 5.24592 1.36882V2.19195C4.78958 2.27968 4.36254 2.44327 3.97403 2.6626L3.41405 2.1295C3.09607 1.82709 2.58113 1.82709 2.26316 2.1295C1.94518 2.43192 1.94518 2.92166 2.26316 3.22408L2.76616 3.70247C2.41672 4.15145 2.16331 4.67216 2.04285 5.23931H1.47799C1.02816 5.23931 0.664062 5.58611 0.664062 6.01341C0.664062 6.44071 1.02816 6.78751 1.47799 6.78751H10.7025ZM6.06039 3.66222C7.13803 3.66222 8.05723 4.32175 8.39419 5.2388H3.72714C4.0641 4.32226 4.98275 3.66222 6.06039 3.66222Z"
        fill="#63B3BE"
      />
    </svg>
  );
};

export const CrossIcon = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.38913 7.58844L10.5546 5.4207C10.6952 5.26091 10.7697 5.05357 10.7629 4.84083C10.7561 4.6281 10.6686 4.42593 10.5181 4.27543C10.3676 4.12492 10.1654 4.03738 9.95266 4.03059C9.73993 4.02379 9.53259 4.09826 9.37279 4.23886L7.20506 6.40436L5.03342 4.23216C4.95563 4.15438 4.86329 4.09268 4.76166 4.05058C4.66003 4.00848 4.5511 3.98682 4.4411 3.98682C4.3311 3.98682 4.22217 4.00848 4.12054 4.05058C4.01891 4.09268 3.92657 4.15438 3.84878 4.23216C3.771 4.30995 3.7093 4.40229 3.6672 4.50392C3.6251 4.60555 3.60344 4.71447 3.60344 4.82448C3.60344 4.93448 3.6251 5.04341 3.6672 5.14504C3.7093 5.24667 3.771 5.33901 3.84878 5.41679L6.02098 7.58844L3.85548 9.75561C3.77056 9.83153 3.70201 9.92397 3.65404 10.0273C3.60607 10.1306 3.57969 10.2426 3.5765 10.3565C3.57331 10.4704 3.59339 10.5837 3.63551 10.6895C3.67762 10.7954 3.74089 10.8915 3.82144 10.9721C3.90199 11.0526 3.99812 11.1159 4.10396 11.158C4.2098 11.2001 4.32312 11.2202 4.43699 11.217C4.55086 11.2138 4.66288 11.1874 4.7662 11.1395C4.86952 11.0915 4.96197 11.0229 5.03788 10.938L7.20506 8.77251L9.37 10.938C9.52709 11.0951 9.74015 11.1834 9.96231 11.1834C10.1845 11.1834 10.3975 11.0951 10.5546 10.938C10.7117 10.7809 10.8 10.5679 10.8 10.3457C10.8 10.1235 10.7117 9.91047 10.5546 9.75338L8.38913 7.58844Z"
        fill="#DE2228"
      />
    </svg>
  );
};

export const ThankYouSpecialIcon = () => {
  return (
    <svg
      width="209"
      height="183"
      viewBox="0 0 240 183"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M175.289 38.1967C181.312 38.7823 193.91 36.8416 196.119 24.394C198.327 11.9464 204.233 8.49995 206.91 8.33264"
        stroke="url(#paint0_linear_507_3357)"
        stroke-width="3"
        stroke-linecap="round"
      />
      <circle cx="121.804" cy="88.9702" r="60.2185" fill="#21005D" />
      <g filter="url(#filter0_d_507_3357)">
        <circle
          cx="121.802"
          cy="88.9703"
          r="51.6531"
          stroke="white"
          stroke-opacity="0.7"
          stroke-width="2"
        />
      </g>
      <path
        d="M148.568 75.7961C148.568 77.4358 147.924 79.019 146.755 80.1498L119.555 106.498C118.327 107.629 116.689 108.307 114.993 108.307C113.297 108.307 111.659 107.629 110.489 106.498L96.8602 93.3238C95.6903 92.193 95.0469 90.6099 95.0469 88.9702C95.0469 87.3305 95.7488 85.8039 96.9186 84.6165C98.147 83.4857 99.7263 82.8638 101.423 82.8072C103.119 82.8072 104.698 83.4292 105.927 84.56L114.993 93.3238L137.688 71.3859C138.917 70.2551 140.496 69.6332 142.192 69.6332C143.888 69.6897 145.468 70.3117 146.696 71.499C147.866 72.6298 148.568 74.1565 148.568 75.7961Z"
        fill="white"
      />
      <path
        d="M166.891 149.188C172.512 150.812 183.381 156.983 181.882 168.676"
        stroke="url(#paint1_linear_507_3357)"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 132.688C10.6268 135.937 29.2248 138.267 34.6026 121.596M34.6026 121.596C35.3869 117.003 34.6027 107.917 25.1917 108.32C23.399 112.746 22.7715 121.596 34.6026 121.596ZM34.6026 121.596C38.5239 122.325 47.6437 121.63 52.7526 113.026"
        stroke="url(#paint2_linear_507_3357)"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="138.897" cy="177.228" r="5.77208" fill="#FFC327" />
      <circle cx="193.467" cy="85.8238" r="5.27208" stroke="#121212" />
      <circle cx="101.837" cy="6.32092" r="6.32092" fill="#121212" />
      <circle cx="119.791" cy="16.9897" r="3.33814" fill="#FFC327" />
      <circle cx="46.2094" cy="66.0132" r="5.35004" stroke="#121212" />
      <circle cx="59.6513" cy="158.257" r="5.93257" stroke="#121212" />
      <circle
        cx="3.07308"
        cy="3.07308"
        r="3.07308"
        transform="matrix(-1 0 0 1 124.023 167.536)"
        fill="#FFC327"
      />
      <defs>
        <filter
          id="filter0_d_507_3357"
          x="65.1484"
          y="35.3171"
          width="113.305"
          height="113.306"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_507_3357"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_507_3357"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_507_3357"
          x1="191.1"
          y1="8.33264"
          x2="191.1"
          y2="38.2886"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#299BFF" />
          <stop offset="1" stop-color="#1276EF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_507_3357"
          x1="174.456"
          y1="149.188"
          x2="174.456"
          y2="168.676"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#299BFF" />
          <stop offset="1" stop-color="#1276EF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_507_3357"
          x1="27.3763"
          y1="108.307"
          x2="27.3763"
          y2="135.002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#299BFF" />
          <stop offset="1" stop-color="#1276EF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CameraIcon = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.3983 17.4325C21.3983 15.0674 19.4803 13.1494 17.1152 13.1494C14.75 13.1494 12.832 15.0674 12.832 17.4325C12.832 19.7977 14.75 21.7157 17.1152 21.7157C19.4803 21.7157 21.3983 19.7977 21.3983 17.4325Z"
        stroke="#FFC327"
        stroke-width="1.82368"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.1118 27.9212C28.0676 27.9212 29.372 24.6386 29.372 17.5259C29.372 12.5404 28.7127 9.87272 24.56 8.72597C24.1787 8.60556 23.7558 8.37621 23.4132 7.99921C22.8599 7.39286 22.4557 5.53082 21.1197 4.96748C19.7837 4.40557 14.4184 4.43137 13.1039 4.96748C11.7909 5.50502 11.3637 7.39286 10.8104 7.99921C10.4678 8.37621 10.0464 8.60556 9.66363 8.72597C5.51095 9.87272 4.85156 12.5404 4.85156 17.5259C4.85156 24.6386 6.156 27.9212 17.1118 27.9212Z"
        stroke="white"
        stroke-width="1.82368"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.7998 12.6692H23.812"
        stroke="white"
        stroke-width="1.82368"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PremiumIcon = () => {
  return (
    <svg
      width="75"
      height="67"
      viewBox="0 0 75 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8299 48.9518C8.75938 48.9518 6.98516 47.4711 6.61478 45.434L0.790113 13.3984C0.0573449 9.36813 4.85603 6.70647 7.88704 9.46194L18.6108 19.2108C20.6273 21.044 23.8202 20.5534 25.1933 18.1995L34.0984 2.93346C35.7516 0.099448 39.8464 0.0994518 41.4996 2.93346L50.4048 18.1995C51.7779 20.5534 54.9708 21.0439 56.9872 19.2108L67.711 9.46194C70.742 6.70647 75.5407 9.36813 74.8079 13.3984L68.9833 45.434C68.6129 47.4711 66.8387 48.9518 64.7682 48.9518H10.8299ZM68.3437 62.0424C68.3437 64.6605 66.5983 66.4059 63.9801 66.4059H11.6179C8.99979 66.4059 7.25438 64.6605 7.25438 62.0424V61.9631C7.25438 59.597 9.17248 57.6789 11.5386 57.6789H64.0595C66.4256 57.6789 68.3437 59.597 68.3437 61.9631V62.0424Z"
        fill="url(#paint0_linear_1151_14088)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1151_14088"
          x1="77.0707"
          y1="66.4059"
          x2="-14.5026"
          y2="36.5362"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FACC15" />
          <stop offset="1" stop-color="#FFE580" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const SaveIcon = () => {
  return (
    <svg
      width="33"
      height="34"
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2044 28.3218C23.846 28.3208 23.4915 28.2489 23.1611 28.11C22.8308 27.9712 22.5312 27.7683 22.2797 27.513L16.3228 21.591L10.3658 27.5169C9.98327 27.9051 9.49263 28.169 8.95789 28.2742C8.42315 28.3794 7.86911 28.3211 7.368 28.1068C6.86192 27.9032 6.42898 27.5518 6.12572 27.0984C5.82246 26.645 5.66297 26.1106 5.66809 25.5652V9.91824C5.66809 8.63379 6.17834 7.40194 7.08658 6.49369C7.99483 5.58544 9.22668 5.0752 10.5111 5.0752L22.1345 5.0752C22.7705 5.0752 23.4002 5.20046 23.9878 5.44385C24.5754 5.68724 25.1093 6.04397 25.559 6.49369C26.0087 6.94341 26.3655 7.4773 26.6089 8.06489C26.8522 8.65248 26.9775 9.28225 26.9775 9.91824V25.5652C26.9829 26.1102 26.824 26.6442 26.5215 27.0976C26.2189 27.5509 25.7868 27.9026 25.2815 28.1068C24.9403 28.2495 24.5741 28.3226 24.2044 28.3218ZM10.5111 7.01241C9.74046 7.01241 9.00135 7.31856 8.45641 7.86351C7.91146 8.40846 7.60531 9.14757 7.60531 9.91824V25.5652C7.60496 25.7266 7.65245 25.8845 7.74179 26.0189C7.83112 26.1533 7.95829 26.2582 8.10723 26.3204C8.25617 26.3826 8.42021 26.3993 8.57861 26.3683C8.73701 26.3373 8.88267 26.2601 8.9972 26.1463L15.6448 19.5394C15.8263 19.359 16.0717 19.2578 16.3276 19.2578C16.5835 19.2578 16.829 19.359 17.0105 19.5394L23.6503 26.1444C23.7649 26.2581 23.9105 26.3354 24.0689 26.3663C24.2273 26.3973 24.3914 26.3807 24.5403 26.3185C24.6892 26.2563 24.8164 26.1514 24.9057 26.0169C24.9951 25.8825 25.0426 25.7246 25.0422 25.5632V9.91824C25.0422 9.14757 24.7361 8.40846 24.1911 7.86351C23.6462 7.31856 22.9071 7.01241 22.1364 7.01241H10.5111Z"
        fill="currentColor"
        fill-opacity="0.8"
      />
    </svg>
  );
};

export const SaveIcon2 = () => {
  return (
    <svg
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.26562 22.1065V5.49577C5.26562 4.92478 5.46911 4.43615 5.87607 4.02988C6.28303 3.62361 6.77166 3.42013 7.34197 3.41943H17.7237C18.2947 3.41943 18.7836 3.62291 19.1906 4.02988C19.5976 4.43684 19.8007 4.92547 19.8 5.49577V22.1065L12.5328 18.992L5.26562 22.1065Z"
        fill="currentColor"
      />
      <rect
        x="9.41797"
        y="7.57227"
        width="6.22902"
        height="1.03817"
        fill="currentColor"
      />
      <rect
        x="8.37891"
        y="8.60986"
        width="8.30536"
        height="1.03817"
        fill="#D9D9D9"
      />
    </svg>
  );
};

export const VideoPlayBtn = () => {
  return (
    <svg
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2515 0.608398C19.5076 0.608398 14.8701 2.01515 10.9257 4.65075C6.98122 7.28635 3.90689 11.0324 2.09145 15.4153C0.276018 19.7981 -0.198983 24.6209 0.726518 29.2737C1.65202 33.9265 3.93645 38.2004 7.29094 41.5549C10.6454 44.9094 14.9193 47.1938 19.5721 48.1193C24.2249 49.0448 29.0477 48.5698 33.4305 46.7544C37.8134 44.9389 41.5595 41.8646 44.1951 37.9201C46.8307 33.9757 48.2374 29.3383 48.2374 24.5943C48.2374 21.4444 47.617 18.3254 46.4116 15.4153C45.2062 12.5052 43.4394 9.861 41.2121 7.6337C38.9848 5.40641 36.3406 3.63962 33.4305 2.43422C30.5204 1.22881 27.4014 0.608398 24.2515 0.608398ZM19.4544 35.3879V13.8006L33.8459 24.5943L19.4544 35.3879Z"
        fill="white"
        fill-opacity="0.9"
      />
    </svg>
  );
};

export const SpecialEventLargeIcon = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 88 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_di_2091_16804)">
        <circle
          cx="43.9892"
          cy="34.6674"
          r="33.9892"
          fill="url(#paint0_linear_2091_16804)"
        />
      </g>
      <path
        d="M35.197 27.7156C35.0036 29.7786 34.8679 33.4295 36.086 34.9835C36.086 34.9835 35.5126 30.9729 40.653 25.9411C42.7227 23.9154 43.2011 21.1603 42.4784 19.094C42.0679 17.9234 41.318 16.9564 40.6666 16.2812C40.2865 15.8842 40.5783 15.2293 41.1314 15.2531C44.4769 15.4024 49.8989 16.332 52.2028 22.1137C53.2139 24.6517 53.2886 27.2745 52.8068 29.9414C52.5014 31.6447 51.4156 35.4313 53.8925 35.8962C55.6603 36.2287 56.5153 34.824 56.8987 33.8129C57.0582 33.3921 57.6113 33.2869 57.9099 33.6229C60.8957 37.0193 61.1502 41.0196 60.5327 44.4635C59.3383 51.1206 52.5964 55.9659 45.8986 55.9659C37.5314 55.9659 30.8709 51.1783 29.1439 42.5126C28.4483 39.0144 28.8012 32.0926 34.1961 27.2067C34.5964 26.8402 35.2513 27.1659 35.197 27.7156Z"
        fill="url(#paint1_radial_2091_16804)"
      />
      <path
        d="M48.4527 40.1646C45.3685 36.1947 46.7494 31.6651 47.5061 29.86C47.6079 29.6225 47.3364 29.3985 47.1227 29.5444C45.796 30.447 43.0782 32.571 41.8126 35.5603C40.0991 39.6013 40.2213 41.5795 41.2358 43.9953C41.8465 45.4509 41.1374 45.7597 40.7811 45.8139C40.435 45.8682 40.1161 45.6375 39.8616 45.3966C39.1295 44.6938 38.6078 43.8008 38.3551 42.8179C38.3008 42.6075 38.026 42.5499 37.9005 42.7229C36.9504 44.036 36.4584 46.1431 36.4347 47.6326C36.36 52.2369 40.1636 55.9692 44.7645 55.9692C50.5632 55.9692 54.7875 49.5564 51.4556 44.1955C50.4885 42.6347 49.5792 41.6134 48.4527 40.1646Z"
        fill="url(#paint2_radial_2091_16804)"
      />
      <defs>
        <filter
          id="filter0_di_2091_16804"
          x="0.201322"
          y="0.678223"
          width="87.5739"
          height="87.5759"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="9.79868" />
          <feGaussianBlur stdDeviation="4.89934" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2091_16804"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2091_16804"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="9.79868" />
          <feGaussianBlur stdDeviation="4.89934" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.8825 0 0 0 0 0.216667 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_2091_16804"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2091_16804"
          x1="43.9892"
          y1="0.678223"
          x2="43.9892"
          y2="68.6566"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5E2590" />
          <stop offset="1" stop-color="#E311B6" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_2091_16804"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(44.2414 56.0714) rotate(-179.751) scale(23.9505 39.298)"
        >
          <stop offset="0.314" stop-color="#FF9800" />
          <stop offset="0.662" stop-color="#FF6D00" />
          <stop offset="0.972" stop-color="#F44336" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_2091_16804"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(45.0835 32.2379) rotate(90.5787) scale(25.0596 18.8592)"
        >
          <stop offset="0.214" stop-color="#FFF176" />
          <stop offset="0.328" stop-color="#FFF27D" />
          <stop offset="0.487" stop-color="#FFF48F" />
          <stop offset="0.672" stop-color="#FFF7AD" />
          <stop offset="0.793" stop-color="#FFF9C4" />
          <stop offset="0.822" stop-color="#FFF8BD" stop-opacity="0.804" />
          <stop offset="0.863" stop-color="#FFF6AB" stop-opacity="0.529" />
          <stop offset="0.91" stop-color="#FFF38D" stop-opacity="0.209" />
          <stop offset="0.941" stop-color="#FFF176" stop-opacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const SpecialEventMapIcon = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.44618 10.8189C9.29478 12.4339 9.18852 15.2921 10.1421 16.5086C10.1421 16.5086 9.69321 13.3689 13.7174 9.42972C15.3377 7.84394 15.7123 5.68707 15.1465 4.06941C14.8251 3.153 14.2381 2.39597 13.7281 1.86738C13.4306 1.5566 13.659 1.04394 14.092 1.06253C16.711 1.17941 20.9557 1.90722 22.7593 6.43347C23.5509 8.42035 23.6093 10.4736 23.2321 12.5614C22.9931 13.8949 22.1431 16.8593 24.0821 17.2232C25.466 17.4835 26.1354 16.3838 26.4356 15.5922C26.5604 15.2628 26.9934 15.1805 27.2271 15.4435C29.5646 18.1024 29.7638 21.2341 29.2804 23.9302C28.3454 29.1418 23.0674 32.9349 17.824 32.9349C11.2737 32.9349 6.05946 29.1869 4.70743 22.4028C4.1629 19.6643 4.43915 14.2455 8.66259 10.4205C8.97603 10.1336 9.48868 10.3886 9.44618 10.8189Z"
        fill="url(#paint0_radial_1149_10811)"
      />
      <path
        d="M20.2179 20.5647C17.8033 17.4569 18.8844 13.9108 19.4768 12.4976C19.5565 12.3117 19.344 12.1364 19.1766 12.2506C18.138 12.9572 16.0104 14.62 15.0196 16.9601C13.6782 20.1237 13.7738 21.6723 14.568 23.5636C15.0462 24.7031 14.491 24.9448 14.2121 24.9873C13.9412 25.0298 13.6915 24.8492 13.4923 24.6606C12.9191 24.1104 12.5107 23.4113 12.3129 22.6419C12.2704 22.4772 12.0552 22.432 11.9569 22.5675C11.2132 23.5955 10.828 25.245 10.8094 26.4111C10.751 30.0156 13.7287 32.9375 17.3305 32.9375C21.8701 32.9375 25.1771 27.9172 22.5687 23.7203C21.8116 22.4984 21.0998 21.6989 20.2179 20.5647Z"
        fill="url(#paint1_radial_1149_10811)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_1149_10811"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.5266 33.0175) rotate(-179.751) scale(18.7498 30.7648)"
        >
          <stop offset="0.314" stop-color="#FF9800" />
          <stop offset="0.662" stop-color="#FF6D00" />
          <stop offset="0.972" stop-color="#F44336" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_1149_10811"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.5802 14.3592) rotate(90.5787) scale(19.6181 14.7641)"
        >
          <stop offset="0.214" stop-color="#FFF176" />
          <stop offset="0.328" stop-color="#FFF27D" />
          <stop offset="0.487" stop-color="#FFF48F" />
          <stop offset="0.672" stop-color="#FFF7AD" />
          <stop offset="0.793" stop-color="#FFF9C4" />
          <stop offset="0.822" stop-color="#FFF8BD" stop-opacity="0.804" />
          <stop offset="0.863" stop-color="#FFF6AB" stop-opacity="0.529" />
          <stop offset="0.91" stop-color="#FFF38D" stop-opacity="0.209" />
          <stop offset="0.941" stop-color="#FFF176" stop-opacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const PremiumCheckIcon = () => {
  return (
    <div>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.7368 11.3148C17.1189 14.4042 14.7896 17.3131 11.521 17.9631C9.92687 18.2806 8.27321 18.087 6.79549 17.41C5.31777 16.733 4.09132 15.607 3.29077 14.1923C2.49022 12.7777 2.15638 11.1466 2.33679 9.53121C2.5172 7.91581 3.20266 6.39852 4.29557 5.19536C6.53722 2.72633 10.3223 2.04667 13.4117 3.28242"
          stroke="#FFD05A"
          stroke-width="1.85363"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.23047 10.0787L10.3198 13.1681L17.7343 5.13574"
          stroke="#FFD05A"
          stroke-width="1.85363"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};
export const NotificationIcon = () => {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3426_7580)">
        <path
          d="M26.1059 23.1277C26.1586 22.7107 26.1586 22.2892 26.1059 21.8722L27.4959 20.8428C27.6283 20.7549 27.6548 20.6168 27.5753 20.441L26.2515 18.2816C26.1721 18.1435 26 18.1059 25.8543 18.1435L24.1996 18.7336C23.8289 18.5202 23.4979 18.3067 23.0875 18.1561L22.836 16.4863C22.8233 16.4121 22.7829 16.3446 22.7222 16.2962C22.6614 16.2478 22.5844 16.2217 22.5051 16.2227H19.8574C19.6985 16.2227 19.5529 16.3357 19.5265 16.4863L19.2882 18.1561C18.8645 18.3067 18.5336 18.5202 18.1629 18.7336L16.5478 18.1435C16.3757 18.1059 16.1904 18.1435 16.111 18.2816L14.7872 20.441C14.7077 20.6168 14.7474 20.7549 14.8666 20.8428L16.2698 21.8722C16.2434 22.0857 16.2169 22.2991 16.2169 22.5C16.2169 22.7008 16.2434 22.9143 16.2698 23.1277L14.8666 24.1572C14.7474 24.245 14.7077 24.4208 14.7872 24.5589L16.111 26.7308C16.1904 26.894 16.3757 26.894 16.5478 26.894L18.1629 26.2287C18.5336 26.4797 18.8645 26.6932 19.2882 26.8564L19.5265 28.5136C19.5529 28.6642 19.6985 28.7772 19.8574 28.7772H22.5051C22.6772 28.7772 22.8095 28.6642 22.836 28.5136L23.0875 26.8564C23.4979 26.6932 23.8289 26.4797 24.1996 26.2287L25.8543 26.894C26 26.894 26.1721 26.894 26.2515 26.7308L27.5753 24.5589C27.6548 24.4208 27.6283 24.245 27.4959 24.1572L26.1059 23.1277ZM21.1812 24.697C19.9104 24.697 18.8645 23.7177 18.8645 22.5C18.8645 21.2822 19.9104 20.3029 21.1812 20.3029C22.4521 20.3029 23.4979 21.2822 23.4979 22.5C23.4979 23.7177 22.4653 24.697 21.1812 24.697ZM12.0204 23.7554H0V22.5L2.64765 19.989V12.4563C2.64765 8.56441 5.29531 5.17468 9.26679 4.04477V3.66814C9.26679 2.28714 10.4582 1.15723 11.9144 1.15723C13.3707 1.15723 14.5621 2.28714 14.5621 3.66814V4.04477C18.5336 5.17468 21.1812 8.56441 21.1812 12.4563V13.7118C20.2678 13.7118 19.3676 13.8499 18.5336 14.0759V12.4563C18.5336 8.94104 15.6212 6.17904 11.9144 6.17904C8.20773 6.17904 5.29531 8.94104 5.29531 12.4563V21.2445H12.0204C11.9542 21.6588 11.9144 22.0731 11.9144 22.5C11.9144 22.9268 11.9542 23.3411 12.0204 23.7554ZM12.3116 25.0109C12.5764 25.7641 12.8941 26.4797 13.3177 27.1326C12.9073 27.3711 12.4307 27.5218 11.9144 27.5218C10.4582 27.5218 9.26679 26.3919 9.26679 25.0109H12.3116Z"
          fill="#21005D"
          stroke="white"
          stroke-width="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_3426_7580">
          <rect
            width="27.62"
            height="27.62"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
